module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"conversionTitle":"Índices de conversão","conversion":{"cards":"Conversão de cartão","boleto":"Conversão de boleto","pix":"Conversão de pix","others":"Outros","cash":"Cash"}},"en-US":{"conversionTitle":"Conversions","conversion":{"cards":"Card conversion","boleto":"Boleto conversion","pix":"Pix conversion","others":"Others","cash":"Cash"}}}')
  delete Component.options._Ctor
}
